module.exports = __webpack_public_path__ + "static/media/Luvdisc_gaussian2.060fc77e.png";